import { TIntlDictionary } from 'types/i18n';
import { TariffFormValues } from 'types/state';
import { stringOrVoid } from 'utils/validation';
import { stringIsEmpty, stringIsNaturalNumber } from 'utils/stringUtils';
import { TFormValidation } from 'types/utils';

export const createTariffFormValidator = (i18n: TIntlDictionary) => (
  values: TariffFormValues
): TFormValidation<TariffFormValues> => {
  return {
    cost: stringOrVoid(
      stringIsEmpty(values.cost),
      i18n.inputValidationRequired
    ),
    expiresAt: stringOrVoid(
      stringIsEmpty(values.expiresAt),
      i18n.inputValidationRequired
    ),
  };
};

export const sanitizeTariffFormValues = (target: HTMLInputElement) => {
  const { name, value } = target;

  switch (name) {
    case 'cost':
      return stringIsEmpty(value) || stringIsNaturalNumber(value);
    default:
      return true;
  }
};
